exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".bsLIKldAvqv5rRfdTLGyN{width:300px}html[dir] .bsLIKldAvqv5rRfdTLGyN{background-color:var(--white)}._155ygoMKXusEF-eJglkS6z{max-height:470px;overflow-x:hidden}._211bP05GW6ZAvTnWYSvOh_{overflow:hidden}", ""]);
// Exports
exports.locals = {
	"callout": "bsLIKldAvqv5rRfdTLGyN",
	"scrollContainer": "_155ygoMKXusEF-eJglkS6z",
	"recipientCollection": "_211bP05GW6ZAvTnWYSvOh_"
};